import {ReactComponent as ProsevoLogo} from './vstarLogo.svg';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { useGetAdminByToken } from "src/API/rest.authentication";
import { setadminDetails } from 'src/redux/admin.slice/admin.slice';
import { useCentralAPI } from 'src/API/centralAPI';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {

    const employeeReducer = useSelector((state: RootState) => state.user.adminDetails);
    const dispatch = useDispatch()
    const {
        adminData,
        adminError,
        getAdminbyTokenRefetch,
        isgetAdminbyTokenError,
        isgetAdminbyTokenFetched,
        isgetAdminbyTokenLoading,
        isgetAdminbyTokenFetching,
    } = useGetAdminByToken({trigger:true});

    const {
        centralData,
        isFetching,
        isFetched,
        isLoading:isLoadingCentralAPI,
        isError,
        error
    } = useCentralAPI({ trigger: !isgetAdminbyTokenError&&!isgetAdminbyTokenFetching })

    if(isgetAdminbyTokenError||isgetAdminbyTokenLoading||isgetAdminbyTokenFetching||isLoadingCentralAPI){
        return <div className=" fixed inset-0 flex items-center justify-center"><ProsevoLogo className=" mx-auto animate-pulse" /></div>
    }

    if(!isgetAdminbyTokenError && !isgetAdminbyTokenLoading && !isgetAdminbyTokenFetching){
        // dispatch(setadminDetails(adminData?.data!))
    }

    return <>{children}</>;
}